export const valueAfter = <T>(value: T, timeout: number): Promise<T> =>
  new Promise(resolve => {
    setTimeout(() => {
      resolve(value)
    }, timeout)
  })

export const errorAfter = <T>(error: Error, timeout: number): Promise<T> =>
  new Promise((_resolve, reject) => {
    setTimeout(() => {
      reject(error)
    }, timeout)
  })

export const sleep = (timeout: number): Promise<void> =>
  valueAfter(undefined, timeout)

export const promiseOrValueAfter = <T>({
  promise,
  timeout,
  value,
}: {
  promise: Promise<T>
  timeout: number
  value: T
}): Promise<T> => Promise.race([promise, valueAfter<T>(value, timeout)])

export const promiseOrErrorAfter = <T>({
  promise,
  timeout,
  error,
}: {
  promise: Promise<T>
  timeout: number
  error?: Error
}): Promise<T> =>
  Promise.race([
    promise,
    errorAfter<T>(error || new Error('Promise timeout'), timeout),
  ])
